import { TModalsIds } from "../../../../../../../app/state/modalSlice/types";
import { createNotification } from "../../../../../../../app/state/notificationSlice/slice";
import { TCaseSolutionPrompt } from "../../../../../../../services/api/instances/casesApi/types";
import { useAppDispatch } from "../../../../../../../services/redux/hooks/use-dispatch";
import { AppButton } from "../../../../../../../shared/components/AppButton";
import { AppLabel } from "../../../../../../../shared/components/AppLabel";
import { AppMarkdownParser } from "../../../../../../../shared/components/AppMarkdownParser";
import { AppNewInput } from "../../../../../../../shared/components/AppNewInput";
import styles from "./styles.module.css";

interface Props {
  solution: TCaseSolutionPrompt;
  closeModal: (id: TModalsIds) => void;
  className?: string;
}

export const CaseSolutionContent = ({ solution, closeModal }: Props) => {
  const dispatch = useAppDispatch();

  const handleCopyPrompt = () => {
    navigator.clipboard.writeText(solution.initial_prompt);
    dispatch(createNotification("success", "Промпт скопирован в буфер обмена"));
    closeModal("case_solution_modal");
  };

  return (
    <div className={styles["solution-container"]}>
      <div className={styles["solution-segment"]}>
        <AppLabel className={styles["solution-label"]}>Тип решения</AppLabel>
        <div className={styles[`solution-type-${solution.solution_type}`]}>
          {solution.solution_type}
        </div>
      </div>
      <div className={styles["solution-segment"]}>
        <AppLabel className={styles["solution-label"]}>Следующие шаги</AppLabel>
        <div className={styles["solution-steps-content"]}>
          {solution.next_steps}
        </div>
      </div>
      <div className={styles["solution-segment"]}>
        <AppLabel className={styles["solution-label"]}>
          Начальный промпт
        </AppLabel>

        <AppMarkdownParser
          content={solution.initial_prompt}
          className={styles.prompt}
        />
      </div>
      <AppButton
        buttonType={"outlined"}
        onClick={handleCopyPrompt}
        className={styles["copy-prompt-btn"]}
      >
        Копировать промпт
      </AppButton>
    </div>
  );
};
